import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PriorityEncoder = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Priority Encoder"
    videos={[
      "https://www.youtube.com/embed/gnoqn705LBg?si=OUQFUgGIvEMLzi7P",
      "https://www.youtube.com/embed/B6TlFeBAjn8?si=rOk4dj3O2NzdV_hx",
      "https://www.youtube.com/embed/po7vQyGuwf0?si=HFOeTp3tvDi4jyoU",
      "https://www.youtube.com/embed/JUqLp6p137k?si=8oU8JyB1zk4-nSUb"
    ]}
    takeaways={[]}
    questions={[
      "1) Design a combinational circuit with inputs D0, D1, D2, D3 and outputs X, Y, V. The operation of the combinational circuit must be such that if two or more inputs are equal to 1 at the same time, highest priority input among the inputs is considered. The order of priority is D0 > D1 > D2 > D3. Here V is the valid bit indicator that is set to 1 when one or more inputs are equal to 1.",
      "2) Write the Test Bench in Verilog to verify the design circuit above."
    ]}
    exampleVideos={[]}
  />
);
}

export default PriorityEncoder;
